// Builds a comma-separated address string including zip from Google place address components.
// Format: "street, city, state, zip, country" — compatible with the backend's fallback parser.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const buildAddressWithZip = async (prediction: any): Promise<string> => {
  const place = prediction.toPlace();
  await place.fetchFields({ fields: ['addressComponents'] });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const components: any[] = place.addressComponents || [];
  const get = (type: string, text: 'shortText' | 'longText') =>
    components.find((c) => c.types.includes(type))?.[text] || '';
  const street = [get('street_number', 'shortText'), get('route', 'shortText')].filter(Boolean).join(' ');
  const city = get('locality', 'longText') || get('sublocality', 'longText');
  const state = get('administrative_area_level_1', 'shortText');
  const zip = get('postal_code', 'shortText');
  const country = get('country', 'longText') || 'United States';
  return [street, city, state, zip, country].filter(Boolean).join(', ');
};
